// Packages and components
import React from 'react';
import { Box, Text } from 'grommet';
import { FormUp, FormDown } from 'grommet-icons';

// Helpers and utilities
import {
  TypographyWeight,
  TypographySettings,
} from '@theme/globals/typography';
import { edgeSize } from '@theme/globals/sizing';
import { pxToRem } from '@theme/utils/sizing';

// Types
import type { SHDSpinnerProps } from './SHDSpinner.d';

const SHDSpinner: React.FC<SHDSpinnerProps> = ({
  className = 'spinner',
  size = 'small',
  value,
  onChangeUp,
  onChangeDown,
}) => {
  const sizing = {
    small: {
      gap: 'xxsmall',
      icon: pxToRem(32),
      type: {
        size: TypographySettings.h4.size,
        weight: TypographyWeight.SEMIBOLD,
        pad: edgeSize.xxsmall,
      },
    },
    medium: {
      gap: 'medium',
      icon: pxToRem(48),
      type: {
        size: TypographySettings.h2.size,
        weight: TypographyWeight.SEMIBOLD,
        pad: edgeSize.small,
      },
    },
    large: {
      gap: 'xlarge',
      icon: pxToRem(48),
      type: {
        size: TypographySettings.h1.size,
        weight: TypographyWeight.SEMIBOLD,
        pad: edgeSize.medium,
      },
    },
  };

  return (
    <Box className={className} align="center" width="100%">
      <Box
        alignContent="center"
        align="center"
        direction="column"
        gap={sizing[size].gap}
        justify="start"
      >
        <Box
          role="button"
          onClick={() => onChangeUp()}
          className={`${className}__up`}
        >
          <FormUp color="brand" size={sizing[size].icon} />
        </Box>
        <Text
          textAlign="center"
          color="gray-900"
          style={{
            display: 'block',
            fontSize: sizing[size].type.size,
            fontWeight: sizing[size].type.weight,
            // padding: sizing[size].type.pad,
            width: '100%',
          }}
        >
          {value}
        </Text>
        <Box
          role="button"
          onClick={() => onChangeDown()}
          className={`${className}__down`}
        >
          <FormDown color="brand" size={sizing[size].icon} />
        </Box>
      </Box>
    </Box>
  );
};

export default SHDSpinner;
